exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-info[data-v-0c536e44] {\n  padding-left: 20px;\n}\n.label-info .label-tag[data-v-0c536e44] {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n[data-v-0c536e44] .el-tag--plain.el-tag--info {\n  border-color: #909399;\n  color: #606266;\n}", ""]);

// exports
